<template>
  <div class="p-online">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>在线教育</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box">
      <div class="box1">
        <div class="box1_left">
          <img src="@/assets/img/business/logo.png" />
          <p class="text1">课房网在线学习平台</p>
          <p class="text2">学生在线学习平台 <br />提供各种学习辅助工具</p>
          <a href="https://www.kefang.net" target="_blank" class="btn"
            >了解更多</a
          >
        </div>
        <div class="box1_right">
          <img class="img" src="@/assets/img/business/img6.png" />
          <img class="ellipse" src="@/assets/img/business/椭圆形.png" />
        </div>
      </div>
      <div class="box1">
        <div class="box1_left">
          <img src="@/assets/img/business/矩形.png" />
          <p class="text1">1+X证书培训学习平台</p>
          <p class="text2">高校继续教育学<br />学生管理<br />在线学习</p>
          <a
            href="https://www.ccasedu.com"
            class="btn"
            style="background: #28b192"
            target="_blank"
            >了解更多</a
          >
        </div>
        <div class="box1_right">
          <img class="img" src="@/assets/img/business/img7.png" />
          <img class="ellipse" src="@/assets/img/business/椭圆形(2).png" />
        </div>
      </div>
      <div class="box1">
        <div class="box1_left">
          <img src="@/assets/img/business/矩形(1).png" />
          <p class="text1">成考宝典APP</p>
          <p class="text2">高校继续教育学<br />学生管理<br />在线学习</p>
          <div class="btn" style="background: #00c15d">扫码体验</div>
        </div>
        <div class="box1_right">
          <img
            class="img"
            style="
              position: absolute;
              bottom: 0px;
              right: 41px;
              z-index: 1;
              box-shadow: 0px 0px 0px 0px;
            "
            src="@/assets/img/business/手机.png"
          />
          <img class="ellipse" src="@/assets/img/business/椭圆形(1).png" />
        </div>
        <div
          class="ewm"
          v-if="list.length"
          :style="{ backgroundImage: 'url(' + list[0].image + ')' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  methods: {
    init() {
      this.params = this.$route.params;
      this.getAjax();
    },
    getAjax() {
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 80px;
  width: 100%;
  height: 280px;
  background: url(~@/assets/img/business/title2.png) no-repeat center;
  background-size: cover;
}
.title_text {
  width: 360px;
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  text-align-last: justify;
  text-align: justify;
  line-height: 84px;
  letter-spacing: 20px;
}
.g-box {
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  flex-wrap: wrap;
  height: 700px;
  margin-bottom: 120px;
}
.box1 {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 520px;
  height: 320px;
  background: #ffffff;
  border: 1px solid #ccc;
}
.box1:hover {
  box-shadow: 0px 0px 16px 0px rgba(168, 170, 184, 0.2);
  border: 0;
  .ewm {
    display: block;
    left: 550px;
  }
}
.box1_right {
  position: relative;
  .ellipse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .img {
    position: absolute;
    bottom: 32px;
    right: 41px;
    z-index: 1;
    box-shadow: 0px 0px 16px 0px rgba(168, 170, 184, 0.2);
  }
}
.box1_left {
  margin-top: 41px;
  margin-left: 40px;
  img {
    vertical-align: middle;
    display: inline-block;
  }
}
.text1 {
  display: inline-block;
  vertical-align: middle;
  height: 37px;
  font-size: 26px;
  font-weight: 500;
  color: #000000;
  line-height: 37px;
  margin-left: 8px;
}
.text2 {
  width: 200px;
  height: 72px;
  font-size: 20px;
  font-weight: 400;
  color: #000000;
  line-height: 36px;
  margin-top: 19px;
}
.btn {
  display: inline-block;
  width: 120px;
  height: 44px;
  background: #3c80e6;
  border-radius: 2px;
  line-height: 44px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  margin-top: 67px;
}
.ewm {
  position: absolute;
  left: 250px;
  top: 30px;
  width: 200px;
  height: 200px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  z-index: -1;
  transition: left 0.8s;
}
</style>
